import { Tabs } from 'antd';
import { CalendarOutlined, MailOutlined, QuestionCircleOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import { Flex, TabsProps, Input } from 'antd';
import { SmallTitle } from "components/Common/Typography/Titles";
import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import StickyBox from 'react-sticky-box';

interface ProjectScreeningSavedSearchesSecondHeaderProps {
    selectedPool: number;
    addTab: (tabNumber: number) => void;
    currentIndex: number;
    setCurrentIndex: React.Dispatch<React.SetStateAction<number>>;
    tabKey: string;
    setTabKey: React.Dispatch<React.SetStateAction<string>>;
    searchQuery: string;
    setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
    handleSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

// Define the TalentPool interface
export interface TalentPool {
    id: number;
    owner: string;
    role?: string;
    totalCandidates: number; // Add this field
}


const ProjectScreeningSavedSearchesSecondHeader: React.FC<ProjectScreeningSavedSearchesSecondHeaderProps> = ({ selectedPool, addTab, currentIndex, setCurrentIndex, tabKey, setTabKey, searchQuery, handleSearchChange }) => {
    const { id } = useParams();
    const numberId = Number(id);
    const [poolName, setPoolName] = useState<any>('');
    const [selectedPoolss, setSelectedPool] = useState<any>('');
    const [allCandidates, setAllCandidates] = useState<number>(0);
    const [shortlistedCandidates, setShortlistedCandidates] = useState<number>(0);
    const [rejectedCandidates, setRejectedCandidates] = useState<number>(0);
    const [importedCandidates, setImportedCandidates] = useState<number>(0);
    const [selectedTalentPoolStatus, setselectedTalentPoolStatus] = useState<string | null>(null);
    const triggerRefresh = useSelector((state: any) => state.talentPool.triggerProjectDetailRefresh);
    const selectedProject = useSelector((state: any) => state.projectSlice?.selected_project);

    const getProjectTalentPoolDetails = () => {
        if (selectedPool != null) {
          const response = selectedProject;
          if (response) {
            setAllCandidates(response?.total_prospective_candidates);
            setShortlistedCandidates(response?.total_chosen_candidates);
            setImportedCandidates(response?.total_imported_candidates);
            setRejectedCandidates(response?.total_rejected_candidates);
            setselectedTalentPoolStatus(response?.status);
            setPoolName(response?.title);
          }
        }
    };

    useEffect(() => {
        setSelectedPool(numberId);
        getProjectTalentPoolDetails();
    }, [selectedPool, triggerRefresh, selectedProject]);

    const onChange = (key: string) => {
        setTabKey(key);
    };

    const items: TabsProps["items"] = [
        {
            key: "1",
            label: (
                <div className="px-2 text-center flex items-center space-x">
                    <UsergroupAddOutlined
                        className={`${tabKey === "1" ? "text-brand-secondary-700" : "text-text-quaternary"
                            }`}
                        style={{ fontSize: "16px", margin: "2px" }} // Adjust the icon size as needed
                    />
                    <SmallTitle
                        text="Candidates"
                        className={`${tabKey === "1" ? "text-brand-secondary-700" : "text-text-quaternary"} hover:text-brand-secondary-700`}
                        font="font-semibold"
                    />
                </div>
            ),
        },
        // {
        //     key: "2",
        //     label: (
        //         <div className="px-2 text-center flex items-center space-x-1">
        //             <QuestionCircleOutlined
        //                 className={`${tabKey === "2" ? "text-brand-secondary-700" : "text-text-quaternary"
        //                     }`}
        //                 style={{ fontSize: "16px", margin: "2px" }}
        //             />
        //             <SmallTitle
        //                 text="Questions"
        //                 className={`${tabKey === "2" ? "text-brand-secondary-700" : "text-text-quaternary"} hover:text-brand-secondary-700`} font="font-semibold"
        //             />
        //         </div>
        //     ),
        // },
        // {
        //     key: "3",
        //     label: (
        //         <div className="px-2 w-24 text-center flex items-center space-x-1">
        //             <MailOutlined
        //                 className={`${tabKey === "3" ? "text-brand-secondary-700" : "text-text-quaternary"
        //                     }`}
        //                 style={{ fontSize: "16px", margin: "2px" }}
        //             />
        //             <SmallTitle text="Settings" className={`${tabKey === "3" ? "text-brand-secondary-700" : "text-text-quaternary"} hover:text-brand-secondary-700`} font="font-semibold" />
        //         </div>
        //     ),
        // },
        // {
        //     key: "4",
        //     label: (
        //         <div className="px-2 text-center flex items-center space-x-1">
        //             <CalendarOutlined
        //                 className={`${tabKey === "4" ? "text-brand-secondary-700" : "text-text-quaternary"
        //                     }`}
        //                 style={{ fontSize: "16px", margin: "2px" }}
        //             />
        //             <SmallTitle text="Time booking" className={`${tabKey === "4" ? "text-brand-secondary-700" : "text-text-quaternary"} hover:text-brand-secondary-700`} font="font-semibold" />
        //         </div>
        //     ),
        // }
    ];


    useEffect(() => {
        setTabKey("1");
    }, [selectedPool]);

    return (
        <>
            <div>
                <StickyBox offsetTop={171} className="z-[1]">
                    <div className="sticky top-0 z-[2]">
                        <div className="pr-6 bg-white flex justify-between items-center border-b border-main-border h-[53px]">
                            <Flex justify="space-between" className="pr-4 h-[51px] border-b bg-white" align="center">
                                <div className="flex gap-2 items-center">
                                    <Tabs
                                        onChange={onChange}
                                        indicator={{ align: "center" }}
                                        // activeKey={tabKey}
                                        style={{ color: "#6941C6" }}
                                        className="mb-0"
                                        tabBarStyle={{
                                            marginBottom: 0,
                                        }}
                                        items={items}
                                    />
                                </div>
                            </Flex>

                            {/* Search Input and Save Draft Button */}
                            <div className="flex items-center gap-4">
                                {/* Search Input */}
                                <Input
                                    placeholder="Start typing name to add candidate"
                                    prefix={<SearchOutlined style={{ color: "#722ed1" }} />}
                                    style={{
                                        width: "300px",
                                        borderRadius: "10px",
                                        borderColor: "#d9d9d9",
                                        padding: "8px 16px",
                                        fontSize: "12px",
                                    }}
                                    value={searchQuery} // Bind the input value to the state
                                    onChange={handleSearchChange} // Use the passed handler
                                />
                            </div>
                        </div>
                    </div>
                </StickyBox>
            </div>
        </>
    );
};

export default ProjectScreeningSavedSearchesSecondHeader;
